export default "__VITE_ASSET__BE5zLqCw__"